module.exports = "/assets/newsletter/bg_center.png?9bgU6WV";